"use client";

import { useTranslations } from "next-intl";
import { Box, CircularProgress, Typography } from "@/components/controls/base-controls";
import { useLoadingStore } from "@/core/utils/loading.store";

const GlobalSpinner: React.FC = () => {
	const t = useTranslations();

	const { isLoading } = useLoadingStore();

	if (!isLoading) return null;

	return (
		<Box
			sx={{
				position: "fixed",
				top: 0,
				left: 0,
				width: "100%",
				height: "100%",
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				backgroundColor: "rgba(255, 255, 255, 0.8)",
				zIndex: 9999,
			}}
		>
			<CircularProgress />

			<Typography id="data-processing" sx={{
				margin: ".5em 0 0 1em"
			}}>{t("misc.processing")}</Typography>
		</Box>
	);
};

export default GlobalSpinner;
